<template>
  <v-container fluid>
    <v-card>
      <v-toolbar flat dark color="secondary">
        <v-toolbar-title>{{ titulo }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <template v-slot:extension>
          <v-tabs v-model="tabAdmin">
            <v-tabs-slider color="white"></v-tabs-slider>
            <v-tab> Inscrições </v-tab>
            <v-tab> Chamadas </v-tab>
            <v-tab> Processos Seletivos </v-tab>
            <v-tab> Usuários </v-tab>
            <v-tab> Dados de Candidatos </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items v-model="tabAdmin">
        <v-tab-item>
          <listagem-candidatos @editarPrematricula="editarPrematricula"></listagem-candidatos>          
        </v-tab-item>

        <v-tab-item>
          <cadastro-chamada></cadastro-chamada>
        </v-tab-item>
        
        <v-tab-item>
          <cadastro-processo-seletivo></cadastro-processo-seletivo>    
        </v-tab-item>
        
        <v-tab-item v-if="isAdministrador">
           <cadastro-usuario-interno></cadastro-usuario-interno>
        </v-tab-item>
        <v-tab-item v-if="isAdministrador">
           <dados-candidatos-chamadas></dados-candidatos-chamadas>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    
    <v-row justify="center">
      <v-dialog v-model="dlgEditar" fullscreen>
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="fecharEdicaoPrematricula">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Análise da Prematricula</v-toolbar-title>
          </v-toolbar>
          <edicao-inscricao @finalizouParecer="atualizarPreMatriculaCandidato" @salvouRascunho="fecharEdicaoPrematricula"
            @excluiuItem="atualizarPreMatriculaCandidato"
            :preMatricula="prematriculaEmEdicao"
          ></edicao-inscricao>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>
<script>
import * as PreMatriculaService from "@/services/prematricula.service";
import EdicaoInscricao from "@/components/EdicaoInscricao.vue";
import CadastroChamada from "@/components/CadastroChamada.vue";
import CadastroProcessoSeletivo from '@/components/CadastroProcessoSeletivo.vue';
import ListagemCandidatos from '@/components/ListagemCandidatos.vue';
import CadastroUsuarioInterno from '../../components/CadastroUsuarioInterno.vue';
import DadosCandidatosChamadas from '../../components/DadosCandidatosChamadas.vue';

export default {
  components: { CadastroChamada, EdicaoInscricao, ListagemCandidatos, CadastroProcessoSeletivo, CadastroUsuarioInterno, DadosCandidatosChamadas},
  name: "home",
  
  data() {
    return {
      titulo: this.$route.meta.titulo,
      tabAdmin: 0,
      dlgEditar: false,
      prematriculaEmEdicao: {},
    };
  }, 
  methods: {   
    atualizarPreMatriculaCandidato(candidato){
      this.$store.commit('candidatos/UPDATE_CANDIDATO', candidato);
      this.fecharEdicaoPrematricula();
    },
    editarPrematricula(candidato) {
      this.$nprogress.start();
      PreMatriculaService.get(candidato.prematricula.id)
        .then((pm) => {
          this.prematriculaEmEdicao = pm;          
          this.dlgEditar = true;        
        })
        .finally(() => this.$nprogress.done());  
    },
    fecharEdicaoPrematricula() {
      this.dlgEditar = false;      
    }
  },
  computed: {
    isAdministrador() {
      return this.$store.getters.loggedUser.role == 'ADMINISTRADOR'
    }
  }
};
</script>
